export const IDENTITY_FIELDS = [
    { path: 'witUserId', label: 'WIT user id', type: 'string', sample: 'usr_1a2b3c' },
    { path: 'displayName', label: 'Имя', type: 'string', sample: 'Анна' },
    { path: 'gender', label: 'Пол', type: 'string', sample: 'female' },
    { path: 'birthdate', label: 'Дата рождения', type: 'date', sample: '1990-05-01' },
    { path: 'source', label: 'Источник', type: 'string', sample: 'web' },
];
export const PAYMENT_FIELDS = [
    { path: 'hasActive', label: 'Есть активная подписка', type: 'boolean', sample: 'true' },
    { path: 'activeCount', label: 'Активных подписок', type: 'number', sample: '1' },
    { path: 'cancelledCount', label: 'Отменённых подписок', type: 'number', sample: '0' },
    { path: 'isCancelled', label: 'Подписка отменена', type: 'boolean', sample: 'false' },
    { path: 'primaryStatus', label: 'Статус подписки', type: 'string', sample: 'ACTIVE' },
    { path: 'planKey', label: 'Тариф', type: 'string', sample: 'premium_monthly' },
    { path: 'gateway', label: 'Платёжный шлюз', type: 'string', sample: 'stripe' },
    { path: 'billingPeriod', label: 'Период оплаты', type: 'string', sample: 'MONTH' },
    { path: 'currency', label: 'Валюта', type: 'string', sample: 'USD' },
    { path: 'billingCyclesPassed', label: 'Циклов оплаты прошло', type: 'number', sample: '3' },
    { path: 'billingCyclesSucceeded', label: 'Успешных циклов оплаты', type: 'number', sample: '3' },
    { path: 'moneyNetAmount', label: 'Чистая сумма (центы)', type: 'number', sample: '2997' },
    { path: 'moneyGrossAmount', label: 'Валовая сумма (центы)', type: 'number', sample: '2997' },
    { path: 'moneyRefundedAmount', label: 'Возвращено (центы)', type: 'number', sample: '0' },
    { path: 'moneyDisputedAmount', label: 'Оспорено (центы)', type: 'number', sample: '0' },
];
export const PORTRAIT_FIELDS = [
    {
        path: 'url',
        label: 'Ссылка на портрет',
        type: 'string',
        sample: 'https://app.example/en/auth/callback?jwtToken=demo&nextUrl=/portraits/123',
    },
    { path: 'name', label: 'Название портрета', type: 'string', sample: 'Портрет родственной души' },
    { path: 'key', label: 'Ключ портрета', type: 'string', sample: 'portrait_soulmate_main' },
];
export const AUTH_FIELDS = [
    {
        path: 'loginUrl',
        label: 'Ссылка для входа',
        type: 'string',
        // Editor-preview placeholder ONLY — the real link (host + path) comes entirely from the
        // app-service response at send time; the service host is env-driven (AUTH_LINK_API_BASE_URL),
        // never hardcoded. Kept host-neutral so it doesn't imply a fixed host.
        sample: 'https://app.example/en/auth/callback?jwtToken=demo&nextUrl=/',
    },
];
//# sourceMappingURL=fields.js.map